import { useState } from "react";
import "./TableV2.css";
import edidIcon from "../../icons/edit.svg";
import viewIcon from "../../icons/Property 1=broken (5).svg";
import deleteIcon from "../../icons/trash.svg";
import api from "../../api/baseUrl";
import Table from "./Table";

import Snackbar from "../SnackBar/SnackBar";


import OrangeGradientButton from "../Button/OrangeGradientButton";
import ExportExcelButton from "../Button/ExportExcelButton";
import TooltipButton from "../Button/TooltipButton";

const Modal = ({ children, onClose, fullScreen = false }) => {
  const handleOverlayClick = (e) => {
    onClose();
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className={`modal ${fullScreen ? "modal-fullscreen" : ""}`}
        onClick={handleModalClick}
      >
        <button className="modal-close" onClick={onClose}>
          ✖
        </button>
        {children}
      </div>
    </div>
  );
};

const TableV2 = ({
  title,
  data = [],
  onRefresh,
  refreshDataSeller,
  refreshDataProducts,
  keyField,
  showViewButton = false,
  type,
  itemsPerPage = 20,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [editingItem, setEditingItem] = useState(null);
  const [viewingItem, setViewingItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [visitors, setVisitors] = useState([]);
  const [products, setProducts] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [snackbar, setSnackbar] = useState({ message: "", type: "info" });
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const brands = ["Troyshi", "Jeyran", "Mishen"];

  const weightOptions = {
    Troyshi: ["1kg", "200g"],
    Jeyran: ["250g", "1kg"],
    Mishen: ["50g"],
  };

  const [errors, setErrors] = useState({});
  const maxLengths = {
    name: 45,
    surname: 45,
    shop_name: 45,
    phone: 14,
    landline_number: 14,
    address: 300,
    city: 45,
    province: 45,
  };

  const handleAddClick = () => {
    setFormData({});
    setEditingItem(null);
    setViewingItem(null);
    setModalOpen(true);
  };

  const handleEditClick = (item) => {
    setFormData(item);
    setEditingItem(item);
    setViewingItem(null);
    setModalOpen(true);
  };

  const handleSeeDetails = async (id) => {
    try {
      let url = "";
      if (type === "visitor") url = "/crud-marketers";
      if (type === "seller") url = "/crud-sellers";

      const result = await api.post(url, { action: "get", id });
      setViewingItem(result.data.message[0]);
      setEditingItem(null);
      setModalOpen(true);
    } catch (error) {
      console.error("خطا در مشاهده:", error);
      setSnackbar({ message: "خطا در مشاهده", type: "error" });
    }
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (value.length > maxLengths[name]) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: `حداکثر طول ${maxLengths[name]} کاراکتر است`,
  //     }));
  //   } else {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: "",
  //     }));
  //   }

  //   setFormData((prev) => ({ ...prev, [name]: value }));


  //   console.log(formData.role);

  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("Change:", name, value); // بررسی کنید هنگام انتخاب چه مقداری چاپ می‌شود
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let body = {};
    let url = "";

    if (type === "product") {
      url = "/crud-products";
      body = editingItem
        ? {
          action: "update",
          id: editingItem.id,
          name: formData.name,
          brand: formData.brand,
          category: formData.category,
          price: parseInt(formData.price, 10),
        }
        : {
          action: "add",
          name: formData.name,
          brand: formData.brand,
          category: formData.category,
          price: parseInt(formData.price, 10),
        };
    }

    if (type === "visitor") {
      url = "/crud-marketers";
      body = editingItem
        ? {
          action: "update",
          id: editingItem.id,
          name: formData.name,
          surname: formData.surname,
          phone_number: formData.phone || "",
          address: formData.address || "",
        }
        : {
          action: "add",
          id: formData.national,
          name: formData.name,
          surname: formData.surname,
          phone_number: formData.phone || "",
          address: formData.address || "",
          role: formData.role,
        };
    }

    if (type === "seller") {
      url = "/crud-sellers";
      body = editingItem
        ? {
          action: "update",
          id: editingItem.id,
          name: formData.name,
          surname: formData.surname,
          phone_number: formData.phone || "",
          landline_number: formData.land_line || "",
          address: formData.address || "",
          city: formData.city || "",
          province: formData.province || "",
          shop_name: formData.shop_name || "",
        }
        : {
          action: "add",
          id: formData.id,
          name: formData.name,
          surname: formData.surname,
          phone_number: formData.phone || "",
          landline_number: formData.landline_number || "", // ← اینجا کلید متفاوت است
          address: formData.address || "",
          city: formData.city || "",
          province: formData.province || "",
          shop_name: formData.shop_name || "",
        };
    }

    try {
      const result = await api.post(url, body);
      setFormData({});
      setModalOpen(false);

      if (result.data.accepted) {
        setSnackbar({ message: "عملیات موفقیت‌آمیز بود!", type: "success" });
        onRefresh();
        refreshDataSeller();
        refreshDataProducts();
      }
    } catch (error) {
      console.error("خطا در ارسال داده:", error);
      setSnackbar({ message: "خطا در ارسال داده", type: "error" });
    }
  };

  const handleDelete = async (id) => {
    try {
      let url = "";
      if (type === "visitor") url = "/crud-marketers";
      else if (type === "seller") url = "/crud-sellers";
      else if (type === "product") url = "/crud-products";

      const result = await api.post(url, { action: "delete", id });
      if (result.data.accepted) {
        setSnackbar({ message: "حذف موفقیت‌آمیز بود", type: "success" });
        onRefresh();
        if (type === "visitor") setVisitors((prev) => prev.filter((item) => item.id !== id));
        if (type === "seller") setSellers((prev) => prev.filter((item) => item.id !== id));
        if (type === "product") setProducts((prev) => prev.filter((item) => item.id !== id));
      } else {
        setSnackbar({ message: "حذف ناموفق بود", type: "error" });
      }
    } catch (error) {
      console.error("خطا در حذف:", error);
      setSnackbar({ message: "خطا در حذف", type: "error" });
    }
  };

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = data.slice(startIndex, startIndex + itemsPerPage);
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };




  return (
    <div className="vendors-table">
      <div className="card-header">
        {title && <strong>{title}</strong>}
        <div className="button-group">
          <ExportExcelButton data={data} />
          <OrangeGradientButton onClick={handleAddClick}>
            {type === "product" ? "افزودن محصول" : type === "seller" ? "افزودن فروشنده" : "افزودن ویزیتور"}
          </OrangeGradientButton>
        </div>
      </div>

      <div className="vendors">
        {currentData.map((item) => (
          <div key={item[keyField]} className="vendor">
            <span className={type === "product" ? "title product-title" : "title"}>
              {type === "product" ? (
                <>
                  <span>{item.name}</span>
                  <span>{item.brand}</span>
                  <span>•</span>
                  <span>{item.category}</span>
                  <span>•</span>
                  <span>{item.price?.toLocaleString()} تومان</span>
                </>
              ) : (
                `${item.name} ${item.surname}`
              )}
            </span>
            <span
              className={`muted ${type === "product" ? "product-extra-class" : ""}`}
            >
              {type === "product"
                ? `${item.brand} •${item.category} • ${item.price?.toLocaleString()} تومان`
                : type === "seller"
                  ? `${item.shop_name} • ${item.province}, ${item.city}`
                  : item.address}
              {type !== "product" ? ` • ${item.phone}` : ""}
            </span>

            <div className="buttons">
              <TooltipButton
                icon={edidIcon}
                alt="ویرایش"
                tooltipText="ویرایش"
                onClick={() => handleEditClick(item)}
              />
              {showViewButton && type !== "product" && (
                <TooltipButton
                  icon={viewIcon}
                  alt="جزئیات"
                  tooltipText="جزئیات"
                  onClick={() => handleSeeDetails(item.id)}
                  className="margin-btn"
                />
              )}
              <TooltipButton
                icon={deleteIcon}
                alt="حذف"
                tooltipText="حذف"
                onClick={() => {
                  setDeleteItemId(item.id);
                  setDeleteModalOpen(true);
                }}
                className="delete-btn margin-btn"
              />
            </div>
          </div>
        ))}
      </div>


      {totalPages > 1 && (
        <div className="pagination">
          <button className="page-btn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>قبلی</button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button key={page} className={`page-btn ${page === currentPage ? "active" : ""}`} onClick={() => handlePageChange(page)}>{page}</button>
          ))}
          <button className="page-btn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>بعدی</button>
        </div>
      )}

      {isModalOpen && (
        <Modal onClose={() => { setModalOpen(false); setEditingItem(null); setViewingItem(null); }} fullScreen={!!viewingItem}>
          {viewingItem ? (
            <>
              <h2 className="modal-title">
                جزئیات {type === "seller" ? "فروشنده" : "ویزیتور"}
              </h2>
              {/* <p>نام: {viewingItem.name}</p> */}
              <p>نام و نام خانوادگی :{viewingItem.name} {viewingItem.surname}</p>
              {/* <p>نام خانوادگی: {viewingItem.surname}</p> */}
              <p>کد ملی:{viewingItem.id}</p>
              <p>شماره تماس: {viewingItem.phone}</p>


                            <p> آدرس : {viewingItem.address}</p>


              {type === "seller" && (
                <>
                  <p>نام فروشگاه: {viewingItem.shop_name}</p>
                  <p>تلفن ثابت: {viewingItem.landline_number}</p>
                  <p>آدرس کامل: {viewingItem.address}, {viewingItem.city}, {viewingItem.province}</p>
                </>
              )}
            </>
          ) : type === "product" ? (
            <>
              <h2 className="modal-title">{editingItem ? "ویرایش محصول" : "افزودن محصول جدید"}</h2>
              <form className="modal-form" onSubmit={handleSubmit}>
                {[
                  { key: "name", label: "نام محصول", type: "text", required: true },
                  { key: "brand", label: "برند", type: "select", options: brands, required: true },
                  {
                    key: "category",
                    label: "وزن",
                    type: "select",
                    options: formData.brand ? weightOptions[formData.brand] : [],
                    required: true,
                  },
                  { key: "price", label: "قیمت (تومان)", type: "number", required: true },
                ].map((field) => (
                  <div key={field.key} className="floating-label-group">
                    {field.type === "select" ? (
                      <select
                        id={field.key}
                        className="role-selector"
                        value={formData[field.key] || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            [field.key]: e.target.value,
                            ...(field.key === "brand" && { category: "" }),
                          })
                        }
                        required={field.required}
                      >
                        <option value="">
                          {field.key === "brand"
                            ? "انتخاب برند"
                            : field.key === "category"
                              ? "انتخاب وزن"
                              : ""}
                        </option>
                        {field.options.map((option) => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </select>
                    ) : (
                      <input
                        id={field.key}
                        type={field.type}
                        value={formData[field.key] || ""}
                        onChange={(e) => setFormData({ ...formData, [field.key]: e.target.value })}
                        placeholder=" "
                        required={field.required}
                      />
                    )}
                    <label htmlFor={field.key}>{field.label}</label>
                  </div>
                ))}
                <button type="submit" className="btn">ذخیره</button>
              </form>
            </>
          ) : type === "seller" ? (
            <>
              <h2 className="modal-title">{editingItem ? "ویرایش فروشنده" : "افزودن فروشنده جدید"}</h2>
              <form className="modal-form" onSubmit={handleSubmit}>
                {["name", "surname", "shop_name", "phone", "landline_number", "address", "city", "province"].map((field) => {
                  const labels = {
                    name: "نام",
                    surname: "نام خانوادگی",
                    shop_name: "نام فروشگاه",
                    phone: "موبایل",
                    landline_number: "تلفن ثابت",
                    address: "آدرس",
                    city: "شهر",
                    province: "استان"
                  };
                  return (
                    <div key={field} className="floating-label-group">
                      <input
                        id={field}
                        type={field.includes("phone") || field === "land_line" ? "tel" : "text"}
                        name={field}
                        value={formData[field] || ""}
                        onChange={handleChange}
                        maxLength={maxLengths[field]}
                        required={["name", "surname", "shop_name"].includes(field)}
                        placeholder=" "
                      />
                      <label htmlFor={field}>{labels[field]}</label>
                      {errors[field] && <span className="error-text">{errors[field]}</span>}
                    </div>
                  );
                })}

                <button type="submit" className="btn">{editingItem ? "ذخیره تغییرات" : "ذخیره فروشنده"}</button>
              </form>
            </>
          ) : (
            <>
              <h2 className="modal-title">{editingItem ? "ویرایش ویزیتور" : "افزودن ویزیتور جدید"}</h2>
              <form className="modal-form" onSubmit={handleSubmit}>
  <div className="floating-label-group">
    <input
      type="text"
      name="name"
      placeholder=" "
      value={formData.name || ""}
      onChange={handleChange}
      required
    />
    <label>نام ویزیتور</label>
  </div>
  <div className="floating-label-group">
    <input
      type="text"
      name="surname"
      placeholder=" "
      value={formData.surname || ""}
      onChange={handleChange}
      required
    />
    <label>نام خانوادگی ویزیتور</label>
  </div>
  <div className="floating-label-group">
    <input
      type="tel"
      name="phone"
      placeholder=" "
      value={formData.phone || ""}
      onChange={handleChange}
    />
    <label>شماره تماس</label>
  </div>
  <div className="floating-label-group">
    <input
      type="text"
      name="address"
      placeholder=" "
      value={formData.address || ""}
      onChange={handleChange}
      required
    />
    <label>آدرس</label>
  </div>

  {/* کد ملی حالا همیشه نمایش داده می‌شود */}
{/* <div className="floating-label-group">
  <input
    type="text"
    name="id"           // نام فیلد id باشه
    placeholder=" "
    value={formData.id || ""}
    onChange={handleChange}
    required
  />
  <label>کد ملی</label>
</div> */}


  {!editingItem && (
    <div className="floating-label-group">
      <select
        className="role-selector"
        name="role"
        value={formData.role || ""}
        onChange={handleChange}
        required
      >
        <option value="" disabled hidden></option>
        <option value="bowner">ادمین کل</option>
        <option value="marketer">ویزیتور</option>
        <option value="manager">مدیر</option>
      </select>
      <label>نقش</label>
    </div>
  )}

  <button type="submit" className="btn">
    {editingItem ? "ذخیره تغییرات" : "ذخیره ویزیتور"}
  </button>
</form>

            </>
          )}
        </Modal>
      )}

      {isDeleteModalOpen && (
        <Modal onClose={() => setDeleteModalOpen(false)}>
          <h3 className="delete-modal-title">آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟</h3>
          <div className="modal-buttons">
            <button className="btn cancel-btn" onClick={() => setDeleteModalOpen(false)}>انصراف</button>
            <button className="btn confirm-btn" onClick={() => { handleDelete(deleteItemId); setDeleteModalOpen(false); }}>تایید</button>
          </div>
        </Modal>
      )}


    </div>
  );
};

export default TableV2;
